<template>
    <div>
        <div class="mainbox">
            <div class="product" v-for="(item, index) in data" :key="index">
                <el-row :gutter="20">
                    <el-col :span="6" v-for="(item, index) in item" :key="index">
                        <div class="productbox" @click="particulars(item)">
                            <p style="height: 240px">
                                <el-image style="width: 100%; height: 240px" :src="item.img" fit="fill"></el-image>
                            </p>
                            <p style="font-size: 13px; color: #333; margin: 5px 0">{{ item.title }}</p>
                            <p style="font-size: 11px; color: #666">{{ item.content }}</p>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <el-divider></el-divider>
        <div class="footer">
            <ul class="putbox">
                <li>芙清fulqun官网</li>
                <li>Beijing FulQun Bio-Technology Co. Ltd</li>
                <li>北京芙清生物科技有限公司©</li>
                <li>地址：北京市丰台区南四环西路186号汉威国际广场二区9号楼6层03-07室</li>
                <li>
                    <a href="https://beian.miit.gov.cn/">京ICP备19037671号-1</a>
                </li>
                <li @click="() => { this.$router.push('/img') }">
                    互联网药品信息服务资格证书
                </li>
            </ul>
            <div class="contactbox">
                <p>400-010-2266</p>
                <p>周一至周五 9:00-17:30</p>
                <p>在线客服</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            images: [
                "https://uplabimg.andupchain.com/%E5%AE%98%E7%BD%91/2d6dd2e5-2093-481b-82df-cd52161e40e5.png",
            ],
            data: [
                [{
                    img: require('../../assets/images/方膜白底.jpg'),
                    title: "医用促愈功能性敷料",
                    content: "【注册证号】吉械注准20192140055",
                    particulars: [
                        require('../../assets/images/方膜.jpg')
                    ],
                    effect: '用于抑制金黄色葡萄球菌、痤疮丙酸杆菌、铜绿假单胞菌皮肤细菌。改善轻、 中、重度痤疮及皮炎、湿疹、美容术后的丘疹、脓疱、结节、囊肿、皮损和红斑、 干燥脱屑、瘙痒症状;预防痤疮愈后早期色素沉着、减少疤痕;保湿、修复皮 肤屏障;预防感染、促进创面愈合。'
                },
                {
                    img: require('../../assets/images/经典面膜白底.jpg'),
                    title: "医用促愈功能性敷料",
                    content: "【注册证号】吉械注准20192140055",
                    particulars: [
                        require('../../assets/images/经典面膜.jpg')
                    ],
                    effect: '用于抑制金黄色葡萄球菌、痤疮丙酸杆菌、铜绿假单胞菌皮肤细菌。改善轻、 中、重度痤疮及皮炎、湿疹、美容术后的丘疹、脓疱、结节、囊肿、皮损和红斑、 干燥脱屑、瘙痒症状;预防痤疮愈后早期色素沉着、减少疤痕;保湿、修复皮 肤屏障;预防感染、促进创面愈合。'
                },
                {
                    img: require('../../assets/images/淡印白膜白底.jpg'),
                    title: "卡波姆湿性修复功能性敷料",
                    content: "【备案凭证编号】吉械注准20192140054",
                    particulars: [
                        require('../../assets/images/淡印白膜.jpg')
                    ],
                    effect: '改善皮炎、湿疹、敏感性皮肤引起的脱皮、红斑、瘙择症状，用于美容、整形术后的保湿修复护理;修复皮肤屏障，促进创面愈合。'
                },
                {
                    img: require('../../assets/images/淡印黑膜白底.jpg'),
                    title: "卡波姆湿性修复功能性敷料",
                    content: "【注册证号】吉械注准20192140054",
                    particulars: [
                        require('../../assets/images/淡印黑膜.jpg')
                    ],
                    effect: '改善皮炎、湿疹、敏感性皮肤引起的脱皮、红斑、瘙择症状，用于美容、整形术后的保湿修复护理;修复皮肤屏障，促进创面愈合。'
                },
                ],
                [{
                    img: require('../../assets/images/水白底.jpg'),
                    title: "液体敷料",
                    content: "【注册证号】吉长械备20180225号",
                    particulars: [
                        require('../../assets/images/水.jpg')
                    ],
                    effect: '本品由含去离子水、以Frappetide为载体的UP-THA和gly等有机高分子发酵复合物组成，所含成分不具有药理学作用。所含成分不可被人体吸收。非无菌提供。'
                },
                {
                    img: require('../../assets/images/乳液白底.jpg'),
                    title: "膏剂敷料",
                    content: "【备案凭证编号】吉长械备20180284号",
                    particulars: [
                        require('../../assets/images/乳液.jpg')
                    ],
                    effect: '本品由含去离子水、以Frappetide为载体的UP-THA和gly等有机高分子发酵复合物组成，所含成分不具有药理学作用。所含成分不可被人体吸收。非无菌提供。'
                },
                ],
            ],
        };
    },
    methods: {
        particulars(data) {
            this.$router.push({
                path: "/particulars",
                query: {
                    data: data,
                },
            });
        },
        go() {
            this.$router.push('/certification')
        }
    },
};
</script>

<style scoped>
* {
    padding: 0;
    margin: 0;
}

.mainbox {
    width: 1200px;
    margin: auto;
}

.product {
    margin: 20px auto;
}

.productbox {
    height: 300px;
    text-align: center;
    border: 1px solid #ddd;
    padding: 10px;
    cursor: pointer;
}

.footer {
    height: 200px;
    padding: 30px;
    background-color: rgb(250, 250, 250);
    display: flex;
    justify-content: space-between;
}

.putbox {
    list-style: none;
    font-size: 12px;
    width: 70%;
    margin-top: 10px;
    padding-left: 10%;
    line-height: 30px;
}

.putbox a {
    text-decoration: none;
    color: #666;
}

.contactbox {
    width: 30%;
    height: 100%;
    text-align: center;
    line-height: 50px;
}

.contactbox p:nth-child(1) {
    color: rgb(65, 110, 179);
    font-size: 28px;
}

.contactbox p:nth-child(2) {
    font-size: 14px;
    color: #666;
}

.contactbox p:nth-child(3) {
    width: 180px;
    height: 36px;
    margin: auto;
    border: 1px solid rgb(65, 110, 179);
    color: rgb(65, 110, 179);
    line-height: 36px;
    cursor: pointer;
}
</style>
